import React from "react";
import styles from "./Services.module.css";
import Icon from "../common/Icon";
import { Reveal } from "../common/Reveal";
import servicesBg from "../../../../images/Officebg.jpg";

const SERVICES = [
  { icon: "Reliability", title: "Reliability", text: "In-depth knowledge of control systems, software, and robotics — built into every automation solution we deliver." },
  { icon: "Experience", title: "Experience", text: "18+ years of hands-on experience across manufacturing processes, industrial automation, and robotics." },
  { icon: "Certified", title: "Certified Solutions", text: "Preferred channel partner and authorised robot service centre for Mitsubishi Electric Factory Automation in India." },
  { icon: "Holistic", title: "Holistic Approach", text: "Emphasising global standards, innovative technologies, trained personnel, and ongoing risk assessment." },
];

export default function Services() {
  return (
    <section className={styles.services} id="services" style={{ backgroundImage: `url(${servicesBg})` }}>
      <Reveal className={styles.sectionIntro}>
        <span className={styles.eyebrow}>what we do</span>
        <h2 className={styles.sectionHeading}>Our Services</h2>
        <p className={styles.sectionSubtext}>We provide smart and cost effective factory automation solutions tailored to your needs.</p>
      </Reveal>
      <div className={styles.servicesGrid}>
        {SERVICES.map((s, i) => {
          const ServiceIcon = Icon[s.icon];
          return (
            <Reveal key={s.title} delay={i * 90} className={styles.serviceCard}>
              <span className={styles.serviceIcon}><ServiceIcon /></span>
              <h3 className={styles.serviceTitle}>{s.title}</h3>
              <p className={styles.serviceText}>{s.text}</p>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
